export { default as TextInput } from './TextInput'
export type { TextInputProps, TextInputType } from './types'
